import React, { FC } from "react";
import { MatterInvoice, AccruedFee, formatPrice } from "../../data-types";
import { Table, Typography } from "antd";
import styles from "./matter-details-modal.css";

const { ["tab-content"]: tabContentClassName, ["header"]: headerClassName } = styles as any;

type BillingTabProps = {
  invoices: MatterInvoice[];
  accruedFee: AccruedFee;
  hasInvoices: boolean;
};

export const BillingTab: FC<BillingTabProps> = ({ invoices, accruedFee, hasInvoices }) => {
  const totalAccruedTime = accruedFee.accruedTimes.reduce((acc, curr) => acc + curr.actualFee, 0);
  const sortedInvoices = [...invoices].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );
  return (
    <div className={tabContentClassName}>
      <div className={headerClassName}>
        {hasInvoices && (
          <div>
            <Typography.Paragraph>
              Unbilled work-in-progress:{" "}
              {formatPrice(totalAccruedTime - accruedFee.amountBilled, accruedFee.currencySymbol)}
            </Typography.Paragraph>
          </div>
        )}
      </div>
      <h4>Invoices</h4>
      <Table
        locale={{
          emptyText: hasInvoices
            ? "No invoice data for this matter"
            : "No Invoice Data - Contact VPD to discuss enabling this feature",
        }}
        dataSource={sortedInvoices}
        columns={[
          {
            title: "Description",
            dataIndex: "description",
            key: "description",
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (value: string) => value.toUpperCase(),
          },
          {
            title: "Total Net",
            dataIndex: "totalFeeNet",
            key: "totalFeeNet",
            render: (value: number) =>
              `${accruedFee.currencySymbol}${value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
          },
          {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (value: string) => new Date(value).toLocaleDateString(),
          },
        ]}
      />
    </div>
  );
};
